module.exports = __webpack_public_path__ + "img/8.3847e3bd.jpg";